import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import appConfig from '@/appConfig';
import SUserLayout from '@slg/web-customer-shared/src/components/layouts/userLayout/SUserLayout.vue';
import { useI18n } from '@/composables';


const __default__ = {
  name: 'SettingsPage',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n();

const items = computed(() => {
  const base = [
    {
      name: t('settings.profile'),
      route: 'profile',
    },
  ];

  base.push({
    name: t('settings.security'),
    route: 'security',
  });

  if (appConfig.isNightCardsSupport) {
    base.push({
      name: t('nightRiderLink.settingsMenuSubtitle'),
      route: 'night-card',
    });
  }

  return base;
});

return { __sfc: true,t, items, SUserLayout }
}

})